import { AxiosError } from 'axios';
import {
  MutationFunction,
  useMutation,
  UseMutationResult,
  useQueryClient
} from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';

type DeleteCommentVariables = {
  session_id: string;
  document_id: string;
  comment_id: string;
};

export const useDeleteComment = (): UseMutationResult<
  void,
  AxiosError<BaseError>,
  DeleteCommentVariables
> => {
  const queryClient = useQueryClient();

  const deleteComment: MutationFunction<void, DeleteCommentVariables> = ({
    session_id,
    document_id,
    comment_id
  }) =>
    Axios.delete(
      DELETE_URL(session_id, document_id, comment_id).deleteComment
    ).then(() => {});

  return useMutation<void, AxiosError<BaseError>, DeleteCommentVariables>(
    deleteComment,
    {
      onSuccess: (_data, vars) => {
        queryClient.invalidateQueries([
          'comments',
          vars.session_id,
          vars.document_id
        ]);
      },
      useErrorBoundary: false
    }
  );
};
